const isNotLoggedIn = error =>
  error?.graphQLErrors?.find(({ type } = {}) => type === "not_logged_in") ??
  false;

export default isNotLoggedIn;
